"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wad = void 0;
const Reader_1 = require("../Reader");
const Util_1 = require("./Util");
function parseDecal(r) {
    const name = r.nstr(16);
    const width = r.ui();
    const height = r.ui();
    r.skip(4 * 4);
    const pixelCount = width * height;
    const pixels = r.arrx(pixelCount, Reader_1.ReaderDataType.UByte);
    r.skip(21 * (pixelCount / 64));
    r.skip(2);
    const palette = r.arrx(768, Reader_1.ReaderDataType.UByte);
    const data = name[0] === '{'
        ? (0, Util_1.paletteWithLastTransToRGBA)(pixels, palette)
        : (0, Util_1.paletteToRGBA)(pixels, palette);
    return {
        type: 'decal',
        name,
        width,
        height,
        data
    };
}
const parseCache = (_r, metadata) => ({
    type: 'cache',
    name: metadata.name
});
function parseTexture(r) {
    const name = r.nstr(16);
    const width = r.ui();
    const height = r.ui();
    r.skip(4 * 4);
    const pixelCount = width * height;
    const pixels = r.arrx(pixelCount, Reader_1.ReaderDataType.UByte);
    r.skip(21 * (pixelCount / 64));
    r.skip(2);
    const palette = r.arrx(768, Reader_1.ReaderDataType.UByte);
    const data = name[0] === '{'
        ? (0, Util_1.paletteWithLastTransToRGBA)(pixels, palette)
        : (0, Util_1.paletteToRGBA)(pixels, palette);
    return {
        type: 'texture',
        name,
        width,
        height,
        data
    };
}
function parseFont(r, metadata) {
    const width = r.ui() && 256;
    const height = r.ui();
    const rowCount = r.ui();
    const rowHeight = r.ui();
    const glyphs = [];
    for (let i = 0; i < 256; ++i) {
        const glyphOffset = r.us();
        const glyphWidth = r.us();
        glyphs.push({
            x: glyphOffset % width,
            y: (Math.floor(glyphOffset / width) / rowHeight) * rowHeight,
            width: glyphWidth,
            height: rowHeight
        });
    }
    const pixelCount = width * height;
    const pixels = r.arrx(pixelCount, Reader_1.ReaderDataType.UByte);
    r.skip(2);
    const palette = r.arrx(256 * 3, Reader_1.ReaderDataType.UByte);
    return {
        type: 'font',
        name: metadata.name,
        width,
        height,
        rowCount,
        rowHeight,
        glyphs,
        data: (0, Util_1.paletteWithLastTransToRGBA)(pixels, palette)
    };
}
const parseUnknown = (r, metadata) => ({
    type: 'unknown',
    name: metadata.name,
    data: r.arrx(metadata.length, Reader_1.ReaderDataType.UByte)
});
function parseEntry(r, metadata) {
    r.seek(metadata.offset);
    switch (metadata.type) {
        case 0x40: {
            return parseDecal(r);
        }
        case 0x42: {
            return parseCache(r, metadata);
        }
        case 0x43: {
            return parseTexture(r);
        }
        case 0x46: {
            return parseFont(r, metadata);
        }
        default: {
            return parseUnknown(r, metadata);
        }
    }
}
class Wad {
    constructor(entries) {
        this.entries = entries;
    }
    static parse(buffer) {
        const r = new Reader_1.Reader(buffer);
        const magic = r.nstr(4);
        if (magic !== 'WAD3') {
            throw new Error('Invalid WAD file format');
        }
        const entryCount = r.ui();
        const directoryOffset = r.ui();
        r.seek(directoryOffset);
        const entriesMetadata = [];
        for (let i = 0; i < entryCount; ++i) {
            const entry = {
                offset: r.ui(),
                diskLength: r.ui(),
                length: r.ui(),
                type: r.b(),
                isCompressed: r.b(),
                name: ''
            };
            r.skip(2);
            entry.name = r.nstr(16);
            entriesMetadata.push(entry);
        }
        const entries = entriesMetadata.map(e => parseEntry(r, e));
        return new Wad(entries);
    }
}
exports.Wad = Wad;
